module.exports = __webpack_public_path__ + "media/volvo/assets/images/1px-978c1bee49d7ad5fc1a4d81099b13e18.png";